// Adapted from: https://codepen.io/lehollandaisvolant/pen/ryrrGx

// Initial state
var scrollPos = 0;

// How close in pixels should be considered "At top"?
// Provide a negative number or zero.
var topRange = 0;

// Initial value
var position = 'top';

function checkScrollPosition()
{
	// detects new state and compares it with the new one
	// At top?
	if ((document.body.getBoundingClientRect()).top >= topRange)
	{
		position = 'top';
	}

	// Going up?
	// else if ((document.body.getBoundingClientRect()).top > scrollPos)
	// {
	// 	position = 'up';
	// }

	// Going down?
	else
	{
		position = 'scrolled';
	}

	// saves the new position for iteration.
	scrollPos = (document.body.getBoundingClientRect()).top;

	return position;
}

// adding scroll event
window.addEventListener('scroll', function()
{
	document.documentElement.dataset.scrollState = checkScrollPosition();
});